import { Component, Input } from '@angular/core';
import { FirmanteEnvioSimpleResultado } from '../../models/envio-simple-confirmacion.model';

@Component({
  selector: 'app-envio-simple-confirmacion-firmantes-grid',
  templateUrl: './envio-simple-confirmacion-firmantes-grid.component.html',
  styleUrls: ['./envio-simple-confirmacion-firmantes-grid.component.css']
})
export class EnvioSimpleConfirmacionFirmantesGridComponent {
  @Input() firmantes: FirmanteEnvioSimpleResultado[] = [];
  @Input() mostrarEmail = false;
  @Input() mostrarTelefono = false;

  trackByCodigo(_index: number, firmante: FirmanteEnvioSimpleResultado): string {
    return firmante.codigo;
  }

  claseEstado(estado: FirmanteEnvioSimpleResultado['estadoEnvio']): string {
    switch (estado) {
      case 'Finalizado':
        return 'envio-confirmacion-grid__estado--ok';
      case 'Error':
        return 'envio-confirmacion-grid__estado--error';
      default:
        return 'envio-confirmacion-grid__estado--proceso';
    }
  }
}
